import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { MellonService} from "../mellon.service";


@Component({
  selector: 'preregister-button',
  templateUrl: './preregister-button.component.html'
})
export class PreregisterButtonComponent implements OnInit {
  env = environment;
  constructor(private mellonService: MellonService) { }

  ngOnInit() {
  }

}
